import React from 'react'
import {Flex, Stack, Text, TextArea, TextInput} from '@sanity/ui'
import type {StringInputProps, StringSchemaType} from 'sanity'

type CharacterCountProps = {
  as?: 'input' | 'textarea'
  max: number
  children?: React.ReactNode
} & StringInputProps<StringSchemaType>

const CharacterCount: React.FC<CharacterCountProps> = ({
  elementProps,
  as = 'input',
  max,
  children,
}) => {
  const chars = elementProps.value?.length || 0
  const Input = as === 'textarea' ? TextArea : TextInput

  return (
    <Stack gap={2}>
      <Input {...elementProps} />
      <Flex>
        {children}

        <Text style={{flexGrow: 1, textAlign: 'right'}} size={1} muted>
          <span
            style={{
              color: chars > max ? 'var(--card-badge-caution-icon-color)' : 'var(--card-success)',
            }}
          >
            {chars}
          </span>
          /{max}
        </Text>
      </Flex>
    </Stack>
  )
}

export default CharacterCount
